import React, { FC } from "react";
import Router from "./router/index";
import { AuthProvider, useAuthContext } from "./pages/auth/AuthProvider";
import AuthContainer from "./pages/auth/AuthContainer";
import { GoogleOAuthProvider } from "@react-oauth/google";

const getRequestedPath = () => {
  const hashPath = window.location.hash.split("?")[0];
  if (hashPath.startsWith("#/")) {
    return hashPath.replace("#", "");
  }
  return window.location.pathname;
};

const isPublicAuthPath = (path: string) =>
  path === "/login" || path === "/register" || path === "/forgot-password" || path === "/reset-password";

const AppContent: FC = () => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated && !isPublicAuthPath(getRequestedPath())) {
    return <AuthContainer />;
  }

  return <Router />;
};

const App: FC = () => {
  return (
    <GoogleOAuthProvider clientId="648244696329-6crqrla61rj2jvf1fs2d1kovnmmtu52q.apps.googleusercontent.com">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </GoogleOAuthProvider>
  );
};

export default App;
